<script setup lang="ts">
import { faArrowUpRight } from '@fortawesome/pro-regular-svg-icons'

import { AppText } from '@shared/ui/typography'
import { AppTooltip } from '@shared/ui/tooltips'
import { LinkTextPrimary } from '@shared/ui/links'
import { AppIcon } from '@shared/ui/icons'
import { BtnSecondary } from '@shared/ui/buttons'

defineOptions({
  name: 'LessonTutorBlock',
})

/** The Tutor block of a lesson form: the tutor as the lesson has them, with the way to the tutor modal. The list of
 *  tutors is never read on the page itself. */
withDefaults(defineProps<{
  name: string | null
  scheduleUrl: string
  scheduleDisabled?: boolean
  changeText: string
  canChange?: boolean
}>(), {
  scheduleDisabled: false,
  canChange: true,
})

const emit = defineEmits<{
  change: []
}>()
</script>

<template>
  <div class="lesson-tutor-block">
    <AppText
      name="body1-medium"
      color="slate-900"
    >
      Tutor
    </AppText>
    <div class="lesson-tutor-block__tutor">
      <div class="lesson-tutor-block__identity">
        <AppText
          name="body1-medium"
          :color="name ? 'slate-900' : 'slate-500'"
          truncate
        >
          {{ name ?? 'Not assigned' }}
        </AppText>
        <AppTooltip
          text="No Tutor"
          mode="disabled"
          placement="bottom"
        >
          <LinkTextPrimary
            :href="scheduleUrl"
            :disabled="scheduleDisabled || !scheduleUrl"
            target="_blank"
          >
            Tutor Calendar
            <template #iconRight>
              <AppIcon :icon="faArrowUpRight" />
            </template>
          </LinkTextPrimary>
        </AppTooltip>
      </div>
      <BtnSecondary
        class="lesson-tutor-block__action"
        :text="changeText"
        :disabled="!canChange"
        @click="emit('change')"
      />
    </div>
  </div>
</template>

<style scoped lang="scss" src="./LessonTutorBlock.scss" />
